import { Action, Selector, State, StateContext } from "@ngxs/store"
import { SamlResponse } from "../../../models/order/saml/saml.model"
import { EnvironmentService } from "../../../services/environment.service"
import { inject, Injectable } from "@angular/core"
import { EncryptDecryptService } from "../../../services/encrypt-decrypt.service"
import { LicResponse } from "../../../models/order/lic/lic.model"

export const ORDER_RESUME_STATE_KEY = 'OrderResumeState'
export const ORDER_RESUME_ACTION_TYPE = {
  SET_LIC_PAYLOAD: `${ORDER_RESUME_STATE_KEY}.SET_LIC_PAYLOAD`,
  SET_SAML_PAYLOAD: `${ORDER_RESUME_STATE_KEY}.SET_SAML_PAYLOAD`,
  SET_RETRIEVE_PAYLOAD: `${ORDER_RESUME_STATE_KEY}.SET_RETRIEVE_PAYLOAD`
}

export interface OrderResumeStateModel {
  samlResponse?: string
  licResponse?: string
  retrieveResponse?: any
}

export class AddSamlPayloadAction {
  static readonly type = ORDER_RESUME_ACTION_TYPE.SET_SAML_PAYLOAD
  constructor(public response: SamlResponse) { }
}

export class AddLicPayloadAction {
  static readonly type = ORDER_RESUME_ACTION_TYPE.SET_LIC_PAYLOAD
  constructor(public response: LicResponse) { }
}
export class AddRetrievePayloadAction {
  static readonly type = ORDER_RESUME_ACTION_TYPE.SET_RETRIEVE_PAYLOAD
  constructor(public response: any) { }
}


@State<OrderResumeStateModel>({
  name: ORDER_RESUME_STATE_KEY,
  defaults: {
    samlResponse: undefined,
    licResponse: undefined,
    retrieveResponse: undefined,
  }
})
@Injectable()
export class OrderResumeState {

  encryptDecryptService: EncryptDecryptService = inject(EncryptDecryptService)
  environmentService: EnvironmentService = inject(EnvironmentService)

  @Action(AddSamlPayloadAction)
  addSamlPayload({ patchState }: StateContext<OrderResumeStateModel>, { response }: AddSamlPayloadAction): void {
    patchState({ samlResponse: this.encryptDecryptService.encrypt(response, this.environmentService.sessionDecryptKey) })
  }

  @Action(AddLicPayloadAction)
  addLicPayload({ patchState }: StateContext<OrderResumeStateModel>, { response }: AddLicPayloadAction): void {
    patchState({ licResponse: this.encryptDecryptService.encrypt(response, this.environmentService.sessionDecryptKey) })
  }

  @Action(AddRetrievePayloadAction)
  addRetrievePayload({ patchState }: StateContext<OrderResumeStateModel>, { response }: AddRetrievePayloadAction): void {
    patchState({ retrieveResponse: response })
  }

  @Selector([OrderResumeState])
  static SamlResponse(state: OrderResumeStateModel) {
    return state?.samlResponse
  }

  @Selector([OrderResumeState])
  static LicResponse(state: OrderResumeStateModel) {
    return state?.licResponse
  }

  @Selector([OrderResumeState])
  static RetrieveResponse(state: OrderResumeStateModel) {
    return state?.retrieveResponse
  }

}
